import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@fronterahealth/frontera-ui-components/ui/select";

import { ReportFieldDisabledValue } from "@components/ReportField/ReportFieldDisabledValue";
import { ReportFieldInputBaseProps } from "@components/ReportField/types";

export const TreatmentPlanSelect: React.FC<ReportFieldInputBaseProps> = ({
  id,
  value,
  onChange,
  selectOptions = [],
  variant,
  disabled,
  onFocus,
  onBlur,
}) => {
  const selected = selectOptions.find((opt) => opt.id === value);
  if (disabled) return <ReportFieldDisabledValue value={selected?.primary} />;
  return (
    <Select
      value={selected?.id ?? undefined}
      onValueChange={(next) => onChange(next ?? "")}
      items={selectOptions.map((opt) => ({ value: opt.id, label: opt.primary }))}
    >
      <SelectTrigger id={id} variant={variant} onFocus={onFocus} onBlur={onBlur}>
        <SelectValue placeholder="--" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {selectOptions.map((opt) => (
            <SelectItem key={opt.id || opt.primary} value={opt.id || opt.primary}>
              {opt.primary}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};
